module.exports = __webpack_public_path__ + "img/white-clock.1c11868a.svg";